import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import type { HTMLAttributes } from 'vue';

    interface Props {
        className?: HTMLAttributes['class'];
    }

    
export default /*@__PURE__*/_defineComponent({
  ...{
        inheritAttrs: false,
    },
  __name: 'Corpay',
  props: {
    className: {}
  },
  setup(__props: any) {

    

    

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("svg", {
    viewBox: "0 0 17 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    class: _normalizeClass(_ctx.className)
  }, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M6.92044 0.0488281L11.0621 0.0560637L11.4455 0.889299C11.5393 1.12625 11.6437 1.38276 11.7594 1.60813L12.4891 3.28494L16.7574 13.1483C16.7128 13.1719 16.0197 13.1485 15.9189 13.1482L13.6206 13.1459L12.2707 13.1533L9.43005 6.60743L8.81979 5.2008L5.3437 13.1513L0.857422 13.1555L6.56288 0.054029L6.92044 0.0488281Z",
      fill: "#BE1549"
    }, null, -1)
  ]), 2))
}
}

})